export enum Colors {
  AzulLinear_1 = 'linear-gradient(80.43deg, #3E50F4 -3.3%, rgba(62, 80, 244, 0.62) 15.39%, rgba(62, 80, 244, 0.19) 42.14%, rgba(255, 255, 255, 0) 90.17%)',

  background_1 = '#3E50F4',

  RosaLinear_2 = 'linear-gradient(80.43deg, #E63EF4 -3.3%, rgba(230, 62, 244, 0.62) 15.39%, rgba(230, 62, 244, 0.19) 42.14%, rgba(255, 255, 255, 0) 90.17%)',

  background_2 ='#E63EF4',

  RosaFracoLinear_3 = 'linear-gradient(80.43deg, #F28BC2 -3.3%, rgba(242, 139, 194, 0.62) 15.39%, rgba(242, 139, 194, 0.19) 42.14%, rgba(255, 255, 255, 0) 90.17%)',

  background_3 ='#F28BC2',

  LaranjaLinear_4 = 'linear-gradient(80.43deg, #F4953E -3.3%, rgba(244, 149, 62, 0.62) 15.39%, rgba(244, 149, 62, 0.19) 42.14%, rgba(255, 255, 255, 0) 90.17%)',

  background_4 ='#F4953E',

  VerdeLinear_5 = 'linear-gradient(80.43deg, #7BDCAD -3.3%, rgba(123, 220, 173, 0.62) 15.39%, rgba(123, 220, 173, 0.19) 42.14%, rgba(255, 255, 255, 0) 90.17%)',

  background_5 = '#7BDCAD',

  AzulFracoLinear_6 = 'linear-gradient(80.43deg, #55AEEF -3.3%, rgba(85, 174, 239, 0.62) 15.39%, rgba(85, 174, 239, 0.19) 42.14%, rgba(255, 255, 255, 0) 90.17%)',

  background_6 = '#55AEEF',

  CinzaLinear_7 = 'linear-gradient(90deg, rgba(155,157,158,0.5270483193277311) 0%, rgba(233,236,239,1) 13%',

  background_7 = '#e9ecef',

  text = '#292929'
}
